import { api } from "@/utils/client";
import { keyBy } from 'lodash-es';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        ids: [],
        list: {},
        meta: {},
        selected: undefined,
        showingDeleted: false
    },
    getters: {
        orderedList(state) {
            return state.ids.map(id => state.list[id]);
        },
        selected(state) {
            return state.list[state.selected];
        }
    },
    mutations: {
        setList(state, list) {
            state.ids = list.map(({id}) => id)
            state.list = keyBy(list, 'id');
        },
        addItem(state, {id, ...item}) {
            state.ids = [id, ...state.ids];
            Vue.set(state.list, id, {id, ...item})
        },
        updateItem(state, {id, ...item}) {
            Vue.set(state.list, id, {id, ...item})
        },
        removeItem(state, id) {
            state.ids = state.ids.filter((_id) => _id !== id);
            Vue.delete(state.list, id)
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
        setShowingDeleted(state, showingDeleted) {
            state.showingDeleted = showingDeleted;
        },
    },
    actions: {
        async getList({commit, rootState}, params) {
            const {data} = await api.get(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/results`, {
                params,
            })
            commit('setList', data);
            return data;
        },
        async getById({commit, rootState}, id) {
            const {data: {data}} = await api.get(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/results/${id}`,)
            commit('addItem', data);
            return data;
        },
        async create({commit, rootState}, payload) {
            const {data: {data}} = await api.post(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/results`, payload)
            commit('addItem', data);
            return data;
        },
        async update({commit, rootState}, {id, ...payload}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/results/${id}`, payload)
            commit('updateItem', data);
            return data;
        },
        async delete({commit, rootState}, id) {
            const {data: {data}} = await api.delete(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/results/${id}`)
            commit('updateItem', data);
            return data;
        },
    }

}
